export enum TableType {
  RemindersList = 'REMINDERS_LIST',
  GroupsCardsList = 'GROUPS_CARDS_LIST',
  GroupsAdministrationList = 'GROUPS_ADMINISTRATION_LIST',
  TagsAdministrationList = 'TAGS_ADMINISTRATION_LIST',
  GroupMembersList = 'GROUP_MEMBERS_LIST',
  GroupMessagesList = 'GROUP_MESSAGES_LIST',
  TgUsersList = 'TG_USERS_LIST',
}
